import { get, call } from 'vuex-pathify'

export default {
    created() {
        this.setSystemDefaultLocale() // Just need to call this method from the VUEX to set the correct language of the system.
    },
    computed: {
        ...get('locale', ['locales', 'currentLocale']),
    },
    methods: {
        ...call('locale', ['setSystemDefaultLocale', 'setSystemCurrentLocale']),
    },
}
